module.exports = __webpack_public_path__ + "static/media/assess-info-icon.704c2376.png";